import {$$, $} from '../dom';

const VIMEO_VIDEO_SELECTOR = '.js-vimeo-video';
const VIMEO_VIDEO_BTN_PLAY_SELECTOR = '.js-vimeo-video--play';
const VIMEO_VIDEO_BTN_MUTE_SELECTOR = '.js-vimeo-video--mute';
const VIMEO_VIDEO_SLIDER = '.js-vimeo-video--slider';
const CLICK_EVENT = 'click';
const START_EVENT = 'vimeo-start';
const PAUSE_EVENT = 'vimeo-pause';
const CLASS_HIDE = 'hide';

const VIMEO_VIDEO_SLIDER_RANGE = '.js-slider-range';
const VIMEO_VIDEO_SLIDER_FORWARD = '.js-vimeo-video--forward';
const VIMEO_VIDEO_SLIDER_BACKWARD = '.js-vimeo-video--backward';
const VIMEO_SUBTITLES_MENU_TRIGGER_SELECTOR = '.js-vimeo-select-subtitles';
const VIMEO_LANGUAGES = '.js-vimeo-languages';



export function vimeoPlayer() {
    const vimeoVideos = $$(VIMEO_VIDEO_SELECTOR)

    if (vimeoVideos.length === 0) {
        return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = "https://player.vimeo.com/api/player.js";


    script.addEventListener('load', () => {

        vimeoVideos.forEach((video: HTMLDivElement) => {
            const id = video.getAttribute('id')
            const autoplay = video.getAttribute('data-autoplay') === 'true';
            const btnPlay = $(VIMEO_VIDEO_BTN_PLAY_SELECTOR,video);
            const btnMute = $(VIMEO_VIDEO_BTN_MUTE_SELECTOR,video);
            const vimeoSlider = $<HTMLDivElement>(VIMEO_VIDEO_SLIDER);
            const vimeoSliderRange = $<HTMLInputElement>(VIMEO_VIDEO_SLIDER_RANGE);
            const vimeoSliderForward = $<HTMLButtonElement>(VIMEO_VIDEO_SLIDER_FORWARD);
            const vimeoSliderBackward = $<HTMLButtonElement>(VIMEO_VIDEO_SLIDER_BACKWARD);
            const vimeoSubtitlesMenuTrigger = $<HTMLInputElement>(VIMEO_SUBTITLES_MENU_TRIGGER_SELECTOR);
            const vimeoLanguages = $<HTMLUListElement>(VIMEO_LANGUAGES);

            if (id === null) {
                return;
            }

            let playing = autoplay;
            let muted = autoplay;

            let observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if(autoplay) {
                            if (entry.isIntersecting) {
                                video.dispatchEvent(new CustomEvent(START_EVENT))
                            } else {
                                video.dispatchEvent(new CustomEvent(PAUSE_EVENT))
                            }
                        }
                    });
                }, {
                    threshold: 0.2
                }
            );
            observer.observe(video);

            let options = {
                controls: false,
                autoplay: autoplay,
                muted: muted,
                responsive: true,
                id: id
            }

            const vimeoPlayer = new Vimeo.Player(id, options);
            vimeoPlayer.disableTextTrack();

            //Get available languages for a video track
            vimeoPlayer.getTextTracks().then(function(tracks) {
                const languagesContainer = document.querySelector('.js-languages-container');
                languagesContainer?.classList.add(CLASS_HIDE);
                const button = createButton('off', 'Off');
                button.addEventListener(CLICK_EVENT, () => {
                    vimeoPlayer.disableTextTrack();
                });
                const listViewItem = createListItem(button);
                vimeoLanguages?.appendChild(listViewItem);

                tracks.forEach(track => {
                    const button = createButton(track.language, track.label);
                    button.addEventListener(CLICK_EVENT, () => {
                        vimeoPlayer.enableTextTrack(track.language).catch(function(error) {
                            switch (error.name) {
                                case 'InvalidTrackLanguageError':
                                    console.log(error.name);
                                    break;

                                case 'InvalidTrackError':
                                    console.log(error.name);
                                    break;

                                default:
                                    break;
                            }
                        });
                    });
                const listViewItem = createListItem(button);
                vimeoLanguages?.appendChild(listViewItem);
                });
            }).catch(function(error) {
                console.log(error);
            });

            //Autoplay start event
            video.addEventListener(START_EVENT, () => {
                vimeoPlayer.play();
                updateSliderPosition();
                vimeoPlayer.on('ended', function(){
                    videoEnded();
                });
            })
            //Autoplay pause event
            video.addEventListener(PAUSE_EVENT, () => {
                vimeoPlayer.pause()
                updateSliderPosition();
                vimeoPlayer.on('ended', function(){
                    videoEnded();
                });
            })

            //Seek event
            vimeoSliderRange?.addEventListener('input', async ( e: InputEvent): Promise<void> => {
                const duration = await vimeoPlayer.getDuration();
                if(e.target){
                    const currentTime = (duration*parseFloat((e.target as HTMLInputElement).value))/100;
                    vimeoPlayer.setCurrentTime(currentTime);
                }
            });

            //Forward the video by 15 seconds
            vimeoSliderForward?.addEventListener(CLICK_EVENT, async ( e: InputEvent): Promise<void> => {
                const currentTime = await vimeoPlayer.getCurrentTime();
                const duration = await vimeoPlayer.getDuration();
                let updatedTime = parseFloat(currentTime) + parseInt(String(15));
                const pos = (parseFloat(String(updatedTime)) / duration)*100;

                vimeoPlayer.setCurrentTime(updatedTime).then(function() {
                    if(vimeoSliderRange){
                        vimeoSliderRange.value = String(pos);
                    }
                }).catch(function(error: { name: any; }) {
                    switch (error.name) {
                        case 'RangeError':
                            console.log(error.name);
                            break;
                        default:
                            break;
                    }
                });
            });

            //Backward the video by 15 seconds
            vimeoSliderBackward?.addEventListener(CLICK_EVENT, async ( e: InputEvent): Promise<void> => {
                const currentTime = await vimeoPlayer.getCurrentTime();
                const duration = await vimeoPlayer.getDuration();
                let updatedTime = parseFloat(currentTime) - parseInt(String(15));
                const pos = (parseFloat(String(updatedTime)) / duration)*100;

                vimeoPlayer.setCurrentTime(updatedTime).then(function() {
                    if(vimeoSliderRange){
                        vimeoSliderRange.value = String(pos);
                    }
                }).catch(function(error: { name: any; }) {
                    switch (error.name) {
                        case 'RangeError':
                            console.log(error.name);
                            break;
                        default:
                            break;
                    }
                });
            });

            //Outside click hide captions language
            window.addEventListener(CLICK_EVENT, function(e){
                const target = <HTMLElement>e.target;
                if (vimeoSubtitlesMenuTrigger?.contains(target)){
                    const languagesContainer = document.querySelector('.js-languages-container');
                    languagesContainer?.classList.remove(CLASS_HIDE);
                } else{
                    const languagesContainer = document.querySelector('.js-languages-container');
                    languagesContainer?.classList.add(CLASS_HIDE);
                }
            });

            //Language captions trigger
            vimeoSubtitlesMenuTrigger?.addEventListener(CLICK_EVENT, () => {
                const languagesContainer = document.querySelector('.js-languages-container');
                languagesContainer?.classList.toggle(CLASS_HIDE);
            });

            btnPlay?.addEventListener(CLICK_EVENT, () => {
                if(playing) {
                    vimeoPlayer.pause();
                    btnPlay?.classList.remove('c-vimeo__control--pause');
                    btnPlay?.classList.add('c-vimeo__control--play');
                    updateSliderPosition();
                    vimeoPlayer.on('ended', function(){
                        videoEnded();
                    });
                } else {
                    vimeoPlayer.play();
                    btnPlay?.classList.remove('c-vimeo__control--play');
                    btnPlay?.classList.add('c-vimeo__control--pause');
                    updateSliderPosition();
                    vimeoPlayer.on('ended', function(){
                        videoEnded();
                    });
                }
                playing=!playing;
            })

            btnMute?.addEventListener(CLICK_EVENT, () => {
                if(!muted) {
                    vimeoPlayer.setVolume(0);
                    btnMute?.classList.remove('c-vimeo__control--unmute');
                    btnMute?.classList.add('c-vimeo__control--mute');
                } else {
                    vimeoPlayer.setVolume(0.5);
                    btnMute?.classList.add('c-vimeo__control--unmute');
                    btnMute?.classList.remove('c-vimeo__control--mute');
                }
                muted=!muted;
            })

            const updateSliderPosition = () => {
                vimeoPlayer.on('timeupdate', async function () {
                    const currentTime = await vimeoPlayer.getCurrentTime();
                    const duration = await vimeoPlayer.getDuration();
                    const pos = (currentTime / duration) * 100;
                    if(vimeoSliderRange) {
                        vimeoSliderRange?.setAttribute('value', String(pos));
                        vimeoSliderRange.value = String(pos);
                    }
                });
            }

            const videoEnded = () => {
                if(vimeoSliderRange){
                    vimeoSliderRange?.setAttribute('value','0');
                    vimeoSliderRange.value = '0';
                }
                btnPlay?.classList.add('c-vimeo__control--play');
                btnPlay?.classList.remove('c-vimeo__control--pause');
                vimeoPlayer.unload().catch(function(error) {
                    console.log(error);
                });
            };

            //Create list item
            const createListItem = (button) => {
                const  listViewItem = document.createElement('li');
                listViewItem.appendChild(button);
                return listViewItem;
            }

            //Create button
            const createButton = (languageCode, textContent) => {
                const button= document.createElement('button');
                button.setAttribute('class', 'js-vimeo-select-subtitles-language');
                button.setAttribute('data-language-code', languageCode);
                button.textContent = textContent;
                return button;
            }
        })
    })
    document.body.appendChild(script);
}
